import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';

export const equipmentTypePaths = {
    '/api/equipmentTypes': {
        get: {
            operationId: 'equipmentTypeControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    name: Type.String(),
                                    id: Type.String(),
                                }),
                            ),
                        },
                    },
                },
            },
            parameters: [{ name: 'payload', in: 'query', schema: Type.String() }],
        },
        post: {
            operationId: 'equipmentTypeControllers.create',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.Optional(Type.String()),
                                name: Type.String(),
                                isPayload: Type.Boolean(),
                                hasLog: Type.Boolean(),
                                created_at: Type.String(),
                                updated_at: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            id: Type.Optional(Type.String()),
                            name: Type.String(),
                            isPayload: Type.Boolean(),
                            hasLog: Type.Boolean(),
                            created_at: Type.String(),
                            updated_at: Type.String(),
                        }),
                    },
                },
            },
        },
    },
    '/api/equipmentTypes/{equipmentTypeId}': {
        parameters: [createPathGuidParameter('equipmentTypeId')],
        get: {
            operationId: 'equipmentTypeControllers.getOne',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Optional(
                                Type.Object({
                                    id: Type.String(),
                                    name: Type.String(),
                                    isPayload: Type.Boolean(),
                                    hasLog: Type.Boolean(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'equipmentTypeControllers.update',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.Optional(Type.String()),
                                name: Type.String(),
                                isPayload: Type.Boolean(),
                                hasLog: Type.Boolean(),
                                created_at: Type.String(),
                                updated_at: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            id: Type.Optional(Type.String()),
                            name: Type.String(),
                            isPayload: Type.Boolean(),
                            hasLog: Type.Boolean(),
                            created_at: Type.String(),
                            updated_at: Type.String(),
                        }),
                    },
                },
            },
        },
        delete: {
            operationId: 'equipmentTypeControllers.remove',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
